import { useEffect, useRef } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { readPushCapabilities } from './support';
import { subscribeThisDevice } from './client';

/**
 * Revalidation silencieuse du push au boot (spec 13 §2/§9) — user CONNECTÉ
 * seulement. Si la permission est déjà `granted` et le navigateur capable, on
 * refait `getToken()` + upsert `POST /push/devices` : MAJ `lastSeenAt` (device
 * frais), rotation de token absorbée, réassignation si un autre compte s'est
 * connecté. Silencieux et fire-and-forget : aucune erreur ne remonte, jamais de
 * permission demandée à froid.
 *
 * Le flag OFF est absorbé sans sonde dédiée : `subscribeThisDevice` charge
 * `GET /push/config` (404 quand OFF → rejet avalé, aucun POST). Une seule
 * tentative par chargement de page (`ref`).
 */
export function usePushRevalidation(): void {
  const { status } = useAuth();
  const attempted = useRef(false);

  useEffect(() => {
    if (status !== 'authenticated' || attempted.current) return;
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    const caps = readPushCapabilities();
    if (!caps.hasServiceWorker || !caps.hasPushManager || !caps.hasNotification) return;
    attempted.current = true;
    // Ne bloque rien, n'affiche rien : c'est une simple mise à jour de fraîcheur.
    void subscribeThisDevice().catch(() => undefined);
  }, [status]);
}
